import { useState } from "react";
import { Form } from "react-bootstrap";
import { useUpdateCompanyAccountMutation } from "../../../../services/ScopeStackAPI";
import { useV2GetAccountQuery } from "@generated";
import GenericToggle from "@components/FormsV2/GenericToggle/GenericToggle";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { saveErrorToast } from "@components/CatalogIndex";
import "./style.css";

export const SalesApprovalSection = () => {
  const { data, isLoading, refetch } = useV2GetAccountQuery({});
  const account = data?.data;
  const [updateCompanyAccount] = useUpdateCompanyAccountMutation();
  const [toast, setToast] = useState<{
    variant: "success" | "danger";
    text: string;
  } | null>(null);

  if (isLoading || !account) return <ScopeStackSpinner />;

  const settings = (account.attributes as any)?.settings ?? {};
  // sales_review is stored on Rails as a boolean string ("true"/"false") or boolean.
  const initialEnabled =
    settings.sales_review === true || settings.sales_review === "true";

  const handleToggle = async (next: boolean) => {
    try {
      await updateCompanyAccount({
        slug: account.id as string,
        data: {
          id: account.id,
          type: (account.type as string) ?? "accounts",
          attributes: {
            settings: { ...settings, sales_review: next },
          } as any,
        },
      } as any);
      await refetch();
      setToast({
        variant: "success",
        text: next
          ? "Sales executive approval enabled."
          : "Sales executive approval disabled.",
      });
    } catch (err) {
      setToast(saveErrorToast(err, "sales executive approval", "update"));
    }
  };

  return (
    <>
      <div className="salesApprovalSection">
        <div className="salesApprovalSection__toggleCell">
          <Form.Label>Add Sales Executive approval?</Form.Label>
          <GenericToggle
            key={`sales-review-${initialEnabled}`}
            initialValueOfIsOn={initialEnabled}
            onToggle={handleToggle}
            onText="Yes"
            offText="No"
            hasText
          />
        </div>
      </div>
      {toast && (
        <ToastAlert
          variant={toast.variant}
          text={toast.text}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};
